/**
 * @voltxampere/ui — 1N4751 30V Zener variant (Sprint 38-3)
 *
 * Reference: Vishay 1N4728-1N4764 series 1N4751 (DO-41 axial Zener).
 *   breakdownVoltage = 30 V           (V_Z @ I_ZT)
 *   breakdownCurrent = 8.5e-3 A       (I_ZT — düşük, yüksek-V)
 *
 * High-V reference / overvoltage protection (örn. 24V industrial bus).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { zener } from "../zener.js";
export const zener1n4751 = {
    id: "1n4751",
    nameTr: "1N4751 (Zener 30V, DO41)",
    nameEn: "1N4751 (30V Zener, DO41)",
    shortcut: "Z",
    category: "active",
    viewBox: zener.viewBox,
    terminals: zener.terminals,
    defaultLabel: "D",
    defaultValue: "1N4751 30V",
    schemaType: "zener",
    defaultParams: { breakdownVoltage: 30, breakdownCurrent: 8.5e-3 },
    renderSVG: () => zener.renderSVG(),
};
//# sourceMappingURL=zener-1n4751.js.map